import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/logo-tenshoku-2.gif'
import _imports_1 from '@/assets/img/apply/img-file-delete.svg'
import _imports_2 from '@/assets/img/common/img-pagetop.svg'
import _imports_3 from '@/assets/img/common/icon-help.svg'


const _withScopeId = n => (_pushScopeId("data-v-677fce84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#E6EFF6"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-jobsearch-detail" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-jobsearch-detail_header_tit" }, "求人票", -1))
const _hoisted_5 = {
  key: 0,
  class: "p-jobsearch-detail_inner"
}
const _hoisted_6 = { class: "p-jobsearch-detail_main js-tab-container" }
const _hoisted_7 = { class: "p-jobsearch-card" }
const _hoisted_8 = { class: "p-jobsearch-card_inner" }
const _hoisted_9 = { class: "p-jobsearch-card_header" }
const _hoisted_10 = { class: "p-jobsearch-tag01" }
const _hoisted_11 = {
  key: 0,
  class: "p-jobsearch-tag01_item __closed js-tooltip-open-button"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "募集終了", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-jobsearch-tooltip js-tooltip-container",
  id: "help-closed"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip_inner" }, [
    /*#__PURE__*/_createElementVNode("p", null, "募集終了ではありますが、応募対応は可能です。同企業の別ポディションで検討いたします。")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip_close js-tooltip-close-trigger" }, "閉じる")
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "p-jobsearch-heading word_break" }
const _hoisted_16 = { class: "p-jobsearch-company" }
const _hoisted_17 = { class: "p-jobsearch-tit" }
const _hoisted_18 = { class: "p-jobsearch-tag02" }
const _hoisted_19 = {
  key: 0,
  class: "p-jobsearch-tag02_item __welcome"
}
const _hoisted_20 = {
  key: 1,
  class: "p-jobsearch-tag02_item __blank"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "p-jobsearch-data" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "p-jobsearch-outline" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "__income" }, "年収", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "__place" }, "勤務地", -1))
const _hoisted_29 = { class: "word_break" }
const _hoisted_30 = {
  key: 0,
  class: "p-jobsearch-logo-wrapper"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-logo" }, [
  /*#__PURE__*/_createTextVNode(" 提供元 : "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "マイナビ転職"
  })
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 0,
  class: "p-jobsearch-tab js-tab"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-jobsearch-tab_item js-tab-btn __current",
  "data-tab": "tab1"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-tab_item_inner" }, "求人情報")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-jobsearch-tab_item js-tab-btn",
  "data-tab": "tab2"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-tab_item_inner" }, "企業情報")
], -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  class: "p-jobsearch-detail_card js-tab-target __current",
  id: "tab1"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-detail_card_hl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-detail_card_hl_ico __icon01" }),
  /*#__PURE__*/_createElementVNode("span", null, "募集要項")
], -1))
const _hoisted_39 = { class: "p-jobsearch-detail_dl" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "仕事内容", -1))
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "経験・スキル", -1))
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { key: 2 }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { key: 4 }
const _hoisted_49 = { key: 5 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "勤務地", -1))
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "採用人数", -1))
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { key: 6 }
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-detail_card_hl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-detail_card_hl_ico __icon02" }),
  /*#__PURE__*/_createElementVNode("span", null, "待遇・福利厚生")
], -1))
const _hoisted_58 = { class: "p-jobsearch-detail_dl" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "雇用形態", -1))
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = { key: 0 }
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = { key: 2 }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "給与", -1))
const _hoisted_66 = ["innerHTML"]
const _hoisted_67 = { key: 4 }
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "手当", -1))
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = { key: 6 }
const _hoisted_72 = ["innerHTML"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "各種保険", -1))
const _hoisted_74 = ["innerHTML"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "福利厚生", -1))
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = { key: 8 }
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-detail_card_hl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-detail_card_hl_ico __icon03" }),
  /*#__PURE__*/_createElementVNode("span", null, "勤務条件・休暇")
], -1))
const _hoisted_80 = { class: "p-jobsearch-detail_dl" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "就業時間", -1))
const _hoisted_82 = ["innerHTML"]
const _hoisted_83 = { key: 0 }
const _hoisted_84 = ["innerHTML"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "休日休暇", -1))
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = { key: 2 }
const _hoisted_88 = ["innerHTML"]
const _hoisted_89 = { key: 4 }
const _hoisted_90 = ["innerHTML"]
const _hoisted_91 = { key: 6 }
const _hoisted_92 = ["innerHTML"]
const _hoisted_93 = { key: 8 }
const _hoisted_94 = ["innerHTML"]
const _hoisted_95 = { key: 10 }
const _hoisted_96 = ["innerHTML"]
const _hoisted_97 = {
  key: 0,
  class: "p-jobsearch-detail_card_hl"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-detail_card_hl_ico __icon04" }, null, -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "選考方法", -1))
const _hoisted_100 = [
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = {
  key: 1,
  class: "p-jobsearch-detail_dl"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "面接回数", -1))
const _hoisted_103 = ["innerHTML"]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "会場名", -1))
const _hoisted_105 = ["innerHTML"]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "選考方法", -1))
const _hoisted_107 = ["innerHTML"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "選考方法備考", -1))
const _hoisted_109 = ["innerHTML"]
const _hoisted_110 = {
  class: "p-jobsearch-detail_card js-tab-target",
  id: "tab2"
}
const _hoisted_111 = { class: "p-jobsearch-detail_card_hl __company word_break" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会社名", -1))
const _hoisted_113 = { class: "__name" }
const _hoisted_114 = { class: "p-jobsearch-detail_dl" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "代表者", -1))
const _hoisted_116 = ["innerHTML"]
const _hoisted_117 = { key: 0 }
const _hoisted_118 = ["innerHTML"]
const _hoisted_119 = { key: 2 }
const _hoisted_120 = ["innerHTML"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "資本金", -1))
const _hoisted_122 = ["innerHTML"]
const _hoisted_123 = { key: 4 }
const _hoisted_124 = ["innerHTML"]
const _hoisted_125 = { key: 6 }
const _hoisted_126 = ["innerHTML"]
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "HP", -1))
const _hoisted_128 = ["href"]
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "事業内容", -1))
const _hoisted_130 = ["innerHTML"]
const _hoisted_131 = { key: 8 }
const _hoisted_132 = ["innerHTML"]
const _hoisted_133 = { key: 10 }
const _hoisted_134 = ["innerHTML"]
const _hoisted_135 = { key: 12 }
const _hoisted_136 = { key: 13 }
const _hoisted_137 = {
  key: 0,
  class: "search_detail_resultamount"
}
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "決算期", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_140 = ["href"]
const _hoisted_141 = {
  key: 2,
  class: "p-jobsearch-btn __applied"
}
const _hoisted_142 = {
  key: 3,
  class: "p-jobsearch-heart js-heart"
}
const _hoisted_143 = ["checked"]
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_icon" }, null, -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_txt" }, "気になる", -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_bubble" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-booster-about_txt" }, "この求人について", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-booster-about_ico" }, null, -1))
const _hoisted_149 = [
  _hoisted_147,
  _hoisted_148
]
const _hoisted_150 = { class: "p-apply_button-wrap" }
const _hoisted_151 = {
  class: "c-modal_inner",
  style: {"max-width":"400px"}
}
const _hoisted_152 = { class: "c-modal_content" }
const _hoisted_153 = { class: "js-apply-tab" }
const _hoisted_154 = { class: "p-apply-modal" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_156 = { class: "p-apply-modal_heading" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-modal_bg js-modal-close-trigger" }, null, -1))
const _hoisted_158 = { class: "p-jobsearch-detail_pagetop" }
const _hoisted_159 = ["onClick"]
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_161 = [
  _hoisted_160
]
const _hoisted_162 = { class: "p-jobsearch-detail_sub" }
const _hoisted_163 = ["href"]
const _hoisted_164 = {
  key: 2,
  class: "p-jobsearch-btn __applied"
}
const _hoisted_165 = {
  key: 3,
  class: "p-jobsearch-heart js-heart"
}
const _hoisted_166 = ["checked"]
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_icon" }, null, -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_txt" }, "気になる", -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_bubble" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-booster-about_txt" }, "この求人について", -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-booster-about_ico" }, null, -1))
const _hoisted_172 = [
  _hoisted_170,
  _hoisted_171
]
const _hoisted_173 = /*#__PURE__*/_createStaticVNode("<img class=\"p-recommend-form__icon-1\" src=\"" + _imports_3 + "\" alt=\"?\" width=\"48\" height=\"48\" data-v-677fce84><p class=\"u-text-center p-recommend-form__text-3\" data-v-677fce84>この求人は『マイナビ転職』に<br data-v-677fce84>掲載されている求人です。</p><p class=\"u-text-center p-recommend-form__text-3\" data-v-677fce84>応募手続きは『マイナビ転職』で<br class=\"u-mn-hidden\" data-v-677fce84>進めてください。また、応募には<br class=\"u-mn-hidden\" data-v-677fce84>『マイナビ転職』の会員登録が<br class=\"u-mn-hidden\" data-v-677fce84>必要となります。</p>", 3)

import { nextTick, onMounted, onBeforeUnmount, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getOrderInfoService } from '@/api/services/trnOrderService';
import { JobDetail } from '@/types';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import store from '@/store';
import { FavoriteDetailResponse, setFavoriteService } from '@/api/services/shintyokuService';
import { getMessageForInvalidOrders } from '@/utils/messageFormat';
import { TrnLikeMypageAddRequest } from '@/types/request';
import { setLikeMypageAddService } from '@/api/services/trnLikeMypageService';
import { AddFavoriteResponse } from '@/types/favorite';
import Loading from '@/components/Loading.vue';
import { domHelperUtils } from '@/utils/domHelper';
import { getCheckApply, getCheckReApply } from '@/api/shintyokuEndpoint';
import { triggerGTMEvent } from '@/utils/gtmEventHelper';

export default /*#__PURE__*/_defineComponent({
  __name: 'JobSearchDetailView',
  setup(__props) {

// src/js/_module/_tooltip.ts
const route = useRoute();
const router = useRouter();
const job = ref<JobDetail>({});
const favoriteIconTop = ref<HTMLInputElement | null>(null);
const favoriteIconBottom = ref<HTMLInputElement | null>(null);
const modalRef = ref<HTMLDivElement | null>(null);
const isShowBoosterInfoModal = ref(false);
const errorMessageFavorite = ref<string>('');
const isShowButonRefusal = ref(false);
const isShowButtonApply = ref(false);
const isShowButtonLike = ref(false);
const isShowButtonAfterApply = ref(false);
const isShowLabelPublic = ref(false);
const isBooster = ref(false);
const isLoading = ref(true);
const isAction = ref(true);
let orderId: string;

const hidePopup = (): void => {
  isShowBoosterInfoModal.value = false;
};

const handleKeyDown = (event: KeyboardEvent): void => {
  // Close modal when ESC key is pressed
  if (event.key === 'Escape' || event.key === 'Esc') {
    hidePopup();
  }
};

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

onMounted(async () => {
  orderId = String(route.params.orderId);  
  if (orderId) {    
    if(route.params.form == 'public')
    {
      isShowLabelPublic.value = true; 
    }
    if(route.params.form == 'booster')
    {
      isShowLabelPublic.value = true; 
      isBooster.value = true; 
    } else {
      if (!Number(route.params.orderId)) {
        isLoading.value = false;
        router.replace({ path: '/mynavi/404' });
        return;
      }
    }
    await loadOrderInfo(orderId, true, isShowLabelPublic.value, isBooster.value);
    isLoading.value = false;
    handleShowButtons();

    // Push job detail data to GTM for analytics tracking
    await triggerGTMEvent(orderId, isShowLabelPublic.value, isBooster.value);

  } else {
    router.replace({ path: '/mynavi/404' });
    return;
  }
  await nextTick();

  // Wait until the browser has finished rendering.
  requestAnimationFrame(() => {
    initializeTooltips();
  });

  document.addEventListener('keydown', handleKeyDown);
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});


// src/js/_module/_tooltip.ts
function initializeTooltips() {
  const tooltipOpenButtons = document.querySelectorAll(".js-tooltip-open-button");
  tooltipOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tooltipContainer = button.querySelector('.js-tooltip-container');      
      if (tooltipContainer) {
        document.querySelectorAll('.js-tooltip-container.is-active').forEach((openTooltip) => {
          if (openTooltip !== tooltipContainer) {
            openTooltip.classList.remove('is-active');
          }
        });
        tooltipContainer.classList.add('is-active');
      }
    });
  });
  const tooltipCloseTriggers = document.querySelectorAll('.js-tooltip-close-trigger');
  tooltipCloseTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const tooltipContainer = trigger.closest('.js-tooltip-container');
      if (tooltipContainer) {
        tooltipContainer.classList.remove('is-active');
      }
    });
  });
    document.addEventListener('click', (event) => {
    const openTooltips = document.querySelectorAll('.js-tooltip-container.is-active');
    openTooltips.forEach((tooltip) => {
      const openButton = tooltip.parentElement;
      if (openButton && !openButton.contains(event.target) && !tooltip.contains(event.target)) {
        tooltip.classList.remove('is-active');
      }
    });
  });
}

const handleShowButtons = () =>
{
    if (isBooster.value === true) {
      isShowButtonLike.value = false;
      isShowButonRefusal.value = false;
      isShowButtonApply.value = false;
      isShowButtonAfterApply.value = false;
      return;
    }

    if(job?.value.trnShintyokuWithCareer && job?.value.trnShintyokuWithCareer.length > 0)
    {
        const statusId = job.value.trnShintyokuWithCareer[0].statusId;
        const isApplied = job.value.trnShintyokuWithCareer[0].isApplied;
        const isRefusal = job.value.trnShintyokuWithCareer[0].isRefusal;
        // case after apply       
        if(MYPAGE_CONSTANTS.TRNSHINTYOKU_STATUS.STATUS_AFTER_APPLY.includes(statusId) && isApplied && !isRefusal)
        {
          isShowButtonAfterApply.value = true;
        }
        else
        {
          // case introduce
          if(MYPAGE_CONSTANTS.TRNSHINTYOKU_STATUS.STATUS_INTRODUE.includes(statusId))
          {
            isShowButtonLike.value = true;
            isShowButonRefusal.value = true;
          }
          isShowButtonApply.value = true;
        }
    }
    else
    {
      // case not exists progress
      isShowButtonApply.value = true;
      isShowButtonLike.value = true;
    }
};

const handleClickSearchCompany = (companyName: string) => {
  sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCH_COMPANY, companyName);
  router.push('/jobsearch/public/');
};

const loadOrderInfo = async (orderId: string, isBrowsing = false, isPublic = false, isBooster = false) => {
  const isNeedCheckValidate = true;
  const orderResp = await getOrderInfoService(orderId, isBrowsing, isNeedCheckValidate, isPublic, isBooster, store);
// Check if orderResp is null, undefined, or an empty object
if (!orderResp || (typeof orderResp === 'object' && Object.keys(orderResp).length === 0)) {
  router.replace({ path: '/mynavi/404' });
  return;
}
store.dispatch('favorites/setFavorite', {orderId, isLike: orderResp.isLiked})
job.value = orderResp;
};

/**
 * Ensures the given URL contains the query parameter `ty=bscv`.
 */
const buildEntryFormUrl = (url?: string) => {
  if (!url) return '';
  const trimmedUrl = new URL(url.trim());
  trimmedUrl.searchParams.set(MYPAGE_CONSTANTS.ENTRY_FORM_TYPE_PARAMS_KEY, MYPAGE_CONSTANTS.ENTRY_FORM_TYPE_PARAMS_VALUE);
  return trimmedUrl.toString();
};

/**
 * Handle the change of job favorite status.
 * @param favorite - Whether to mark as favorite or not.
 */
const handleChangeJobFavorite = async (favorite: boolean) => {
  if(!isAction.value)
  {
    return;
  }
  isAction.value = false;
  // Check if both favorite icons are available (mounted in DOM)
  const hasBothFavoriteIcons = !!favoriteIconTop.value && !!favoriteIconBottom.value;
  // Proceed only if all conditions are met
  if (!!orderId && hasBothFavoriteIcons) {
    // Submit the favorite change
    await handleSubmitChangeJobFavoriteType(favorite);
  }
  isAction.value = true;
};

/**
 * Handles submission to change the favorite status of a job.
 * Supports both referred and public jobs, and updates UI state accordingly.
 *
 * @param jobHasProgress - Whether the job has progress (i.e., referred job)
 * @param favorite - Desired favorite status (true = add to favorite, false = remove)
 */
const handleSubmitChangeJobFavoriteType = async (favorite: boolean) => {
  if (orderId) {
    let favoriteJobError = '';
    if (isShowLabelPublic.value) {
      const publicJobResponse = await handleSubmitPublicJob(parseInt(orderId), favorite);
      favoriteJobError = handleShowMessagePublicJob(publicJobResponse);
    } else {
      const referredJobResponse = await handleSubmitReferredJob(parseInt(orderId), favorite);
      favoriteJobError = handleShowMessageReferredJob(referredJobResponse);
    }
    // If there was an error, do not change the favorite state, Otherwise, toggle favorite state
    const shouldUpdateFavorite = favoriteJobError.length > 0 ? favorite : !favorite;
    // Update favorite icon and buttons on UI
    updateJobLikedStatus(shouldUpdateFavorite);
    setFavoriteIconsCheckedState(shouldUpdateFavorite);

    if(favoriteJobError.length == 0) {
      store.dispatch('favorites/setFavorite', {orderId, isLike: !favorite})
    }
  }
};

/**
 * Show or hide the modal error dialog.
 * 
 * @param isShow - If true, show the modal; if false, hide it and clear the error message.
 */
const handleShowModalError = (isShow: boolean) => {
  // Check that the modal element reference exists
  if (modalRef.value) {
    if (isShow) {
      // Show the modal by adding the 'is-active' class
      modalRef.value.classList.add('is-active');
    } else {
      // Hide the modal by removing the 'is-active' class
      modalRef.value.classList.remove('is-active');
      // Clear the error message when the modal is hidden
      errorMessageFavorite.value = '';
    }
  }
};

const handleShowBoosterInfoModal = (isShow: boolean) => {
  if (isShow) {
    isShowBoosterInfoModal.value = true;
    return;
  }

  hidePopup();
};

/**
 * Submit favorite status for referred jobs.
 * @param orderId - The order ID.
 * @param favorite - Whether the job is a favorite.
 * @returns Promise from setFavorite API call.
 */
const handleSubmitReferredJob = async (orderId: number, favorite: boolean) => {
  const requestParams = {
    orderIds: [orderId], // Array of order IDs (even if only one)
    isFavorite: !favorite,
  };
  // Call the API to set favorite status
  return await setFavoriteService(requestParams);
};

/**
 * Submit like status for public jobs on MyPage.
 * @param orderId - The order ID.
 * @param favorite - Whether the job is a favorite (like).
 * @returns Promise from setLikeMypageAdd API call.
 */
const handleSubmitPublicJob = async (orderId: number, favorite: boolean) => {
  const requestParams: TrnLikeMypageAddRequest = {
    orderId: orderId,
    addLikeFlag: favorite ? 0 : 1,
  };
  // Call the API to set like status
  return await setLikeMypageAddService(requestParams);
};

/**
 * Sets the checked state for both favorite icons.
 * @param checked - The checked state to apply (true or false).
 */
const setFavoriteIconsCheckedState = (checked: boolean) => {
  // Check if both favorite icon elements exist
  if (favoriteIconTop.value && favoriteIconBottom.value) {
    favoriteIconTop.value.checked = checked;
    favoriteIconBottom.value.checked = checked;
  }
};

/**
 * Updates the isLiked property of the job detail if its value differs from the provided checked state.
 * @param checked - The new liked state to set.
 */
const updateJobLikedStatus = (checked: boolean) => {
  if (job.value && job.value.isLiked !== checked) {
    job.value.isLiked = checked;
  }
};

/**
 * Handle show message
 * @param detailResp the value response of the API submit Favorite (Referred Job)
 */
const handleShowMessageReferredJob = (detailResp: FavoriteDetailResponse) => {
  let msg = '';
  if (!detailResp) {
    msg = MYPAGE_CONSTANTS.STRING.ERROR_FAVORITE;
  } else {
  const ignoreOrder = detailResp.ignoreOrder;
  const orders = [{ orderId: Number(job.value.orderId), realClientName: job.value.companyName, positionName: job.value.jobTitle }];
  if (ignoreOrder.length) {
    msg += MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_SINGLE + getMessageForInvalidOrders(orders);
  }
  const unApprovedOrder = detailResp.unApprovedOrder;
  if (unApprovedOrder.length) {
    const orders = [{ orderId: Number(job.value.orderId), realClientName: job.value.companyName, positionName: job.value.jobTitle }];
    msg += MYPAGE_CONSTANTS.STRING.NO_ACCESS_RIGHTS + getMessageForInvalidOrders(orders);
  }
  }
  // Show message success or error
  const msgAction = job.value.isLiked ? MYPAGE_CONSTANTS.STRING.UN_FAVORITE_DONE : MYPAGE_CONSTANTS.STRING.FAVORITE_DONE;
  store.dispatch('toasts/appendTimeToast', { label: msg.length > 0 ? msg : msgAction });
  return msg;
};

/**
 * Handle show message
 * @param publicJobResponse the value response of the API submit Favorite (Public Job)
 */
const handleShowMessagePublicJob = (publicJobResponse: AddFavoriteResponse) => {
  let msg = '';
  if (publicJobResponse.exceptionResponse) {
    const exception = publicJobResponse.exceptionResponse;
    switch (exception.statusCode) {
      case 405:
        msg = MYPAGE_CONSTANTS.FAVORITE_HTTP_CODE.METHOD_NOT_ALLOWED;
        break;
      case 401:
      case 403:
        msg = MYPAGE_CONSTANTS.FAVORITE_HTTP_CODE.SESSION_TIMEOUT;
        break;
      case 400:
        msg = MYPAGE_CONSTANTS.FAVORITE_HTTP_CODE.ERROR_OCCURRED;
        break;
      case 500:
        msg = MYPAGE_CONSTANTS.FAVORITE_HTTP_CODE.COMMUNICATION_FAILED;
        break;
    }
  }
  
  if (msg.length > 0) {
    handleShowModalError(true);
    errorMessageFavorite.value = msg;
  } else {
    let msgAction = job.value.isLiked ? MYPAGE_CONSTANTS.STRING.UN_FAVORITE_DONE : MYPAGE_CONSTANTS.STRING.FAVORITE_DONE;
    if (publicJobResponse.responseFault && publicJobResponse.responseFault.responseId !== 'N011') {
      const orders = [{ orderId: Number(job.value.orderId), realClientName: job.value.companyName, positionName: job.value.jobTitle }];
      if (publicJobResponse.detail && publicJobResponse.detail.ignoreOrderId){
        msgAction = MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_SINGLE + getMessageForInvalidOrders(orders);
      } else {
        msgAction = MYPAGE_CONSTANTS.STRING.NO_ACCESS_RIGHTS + getMessageForInvalidOrders(orders);
      }
      msg = msgAction;
    }
    store.dispatch('toasts/appendTimeToast', { label: msgAction });
  }
  return msg;
};

/**
 * Returns the navigation path based on the given order progress type.
 *
 * @param orderProgressType - The progress type of the order.
 * @returns The corresponding route path as a string, or an empty string if not recognized.
 */
const handleNavigateToApplyByProgress = (orderProgressType?: string): string => {
  if (orderProgressType === 'REFUSAL') {
    return 'reApply';
  } else if (orderProgressType === 'INTRODUCTION') {
    return 'jobSearch';
  } else if (orderProgressType === 'PUBLIC') {
    return 'public';
  } else {
    return '';
  }
};

/**
 * Handle redirect when pressed button back on the mobile mode.
 */
const handleBack = () => {
  window.history.back();
};

async function checkProgress(type: string){
  isAction.value = false;
  let res;
  if(type == "reApply"){
    res = await getCheckReApply(job.value.orderId);
  }else{
    res = await getCheckApply(job.value.orderId);
  }

  if(res && res.responseFaultDetail){
    const order = [{ orderId: Number(job.value.orderId), realClientName: job.value.companyName, positionName: job.value.jobTitle }];
    isAction.value = true;
    if(res.responseFaultDetail.ignoredOrder){
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_SINGLE + getMessageForInvalidOrders(order)});
    }else if(res.responseFaultDetail.reApplyDeniedOrder){
      if(type == "reApply"){
        store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.REAPPLY_DENY_MESG + getMessageForInvalidOrders(order)});
      }else{
        store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.NO_SEL_ON_BRIEFING_SESSION + getMessageForInvalidOrders(order)});
      }
    } else {
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.FAIL_UPDATE_PROGRESS_MSG});
    }
  }else{
    isAction.value = true;
    if(type == "refusal"){
      router.push('/refusal/form/' + job.value.orderId);
    }else{
      router.push('/apply/form/' + job.value.orderId + '/' + type);
    }
  }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("div", { class: "p-jobsearch-detail_header" }, [
            _hoisted_4,
            _createElementVNode("button", {
              class: "p-jobsearch-detail_header_back",
              onClick: handleBack
            }, "戻る")
          ]),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("ul", _hoisted_10, [
                          (job.value?.recruitClosed && !isBooster.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_11, _hoisted_14))
                            : _createCommentVNode("", true),
                          (!isShowLabelPublic.value && job.value?.hasProgress && job.value.trnShintyokuWithCareer[0].isRecommendedByStaff)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 1,
                                class: _normalizeClass(["p-jobsearch-tag01_item", job.value?.recruitClosed ? '__gray' : ''])
                              }, "担当者おすすめ", 2))
                            : _createCommentVNode("", true),
                          (!isShowLabelPublic.value && job.value?.hasProgress && job.value.trnShintyokuWithCareer[0].isRecommendedByClient)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 2,
                                class: _normalizeClass(["p-jobsearch-tag01_item", job.value?.recruitClosed ? '__gray' : ''])
                              }, "弊社企業担当おすすめ", 2))
                            : _createCommentVNode("", true),
                          (!isShowLabelPublic.value && job.value?.hasProgress && job.value.trnShintyokuWithCareer[0].isNewRecommended)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 3,
                                class: _normalizeClass(["p-jobsearch-tag01_item", job.value?.recruitClosed ? '__gray' : ''])
                              }, "新着レコメンド", 2))
                            : _createCommentVNode("", true),
                          (!isShowLabelPublic.value && job.value?.hasProgress && job.value.trnShintyokuWithCareer[0].isAiRecommended)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 4,
                                class: _normalizeClass(["p-jobsearch-tag01_item", job.value?.recruitClosed ? '__gray' : ''])
                              }, "AIおすすめ", 2))
                            : _createCommentVNode("", true),
                          (isShowLabelPublic.value || (job.value?.hasProgress && job.value.trnShintyokuWithCareer[0].isJobSearchPublic))
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 5,
                                class: _normalizeClass(["p-jobsearch-tag01_item __public", job.value?.recruitClosed ? '__gray' : ''])
                              }, "公開求人から検索", 2))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("p", _hoisted_16, _toDisplayString(job.value?.companyName), 1),
                          _createElementVNode("h1", _hoisted_17, _toDisplayString(job.value?.jobTitle), 1)
                        ]),
                        _createElementVNode("ul", _hoisted_18, [
                          (!isShowLabelPublic.value && job.value?.hasProgress && job.value.trnShintyokuWithCareer[0].isWelcome && !isBooster.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_19, "応募歓迎"))
                            : _createCommentVNode("", true),
                          (job.value?.pickupLink && !isBooster.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                _createElementVNode("a", {
                                  href: job.value.pickupLink || '#',
                                  target: "_blank"
                                }, "PICK UP", 8, _hoisted_21)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_22, [
                          (!isShowLabelPublic.value && job.value?.introductionDate && !isBooster.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "紹介日：" + _toDisplayString(job.value?.introductionDate), 1))
                            : _createCommentVNode("", true),
                          (job.value?.updateDate)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "更新日：" + _toDisplayString(job.value?.updateDate), 1))
                            : _createCommentVNode("", true),
                          (job.value.orderId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "求人ID：" + _toDisplayString(job.value?.orderId), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("dl", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("dd", null, _toDisplayString(job.value?.annualIncome), 1),
                        _hoisted_28,
                        _createElementVNode("dd", _hoisted_29, _toDisplayString(job.value?.location), 1),
                        (isBooster.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (!isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_36))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("dl", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.jobDescription
                      }, null, 8, _hoisted_41),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_42, "仕事内容補足"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 1,
                            class: "word_break",
                            innerHTML: job.value?.wkcontentsUpdRange
                          }, null, 8, _hoisted_43))
                        : _createCommentVNode("", true),
                      _hoisted_44,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.necessaryexp
                      }, null, 8, _hoisted_45),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_46, "学歴"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 3,
                            class: "word_break",
                            innerHTML: job.value?.lstschl
                          }, null, 8, _hoisted_47))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_48, "語学"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_49, [
                            (job.value?.languageSkill)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_50, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.value?.languageSkill, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_51,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.workLocation
                      }, null, 8, _hoisted_52),
                      _hoisted_53,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.employeenNum
                      }, null, 8, _hoisted_54),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_55, "募集背景備考"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 7,
                            class: "word_break",
                            innerHTML: job.value?.orderReasonMemo
                          }, null, 8, _hoisted_56))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_57,
                    _createElementVNode("dl", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.emptype
                      }, null, 8, _hoisted_60),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_61, "雇用期間"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 1,
                            class: "word_break",
                            innerHTML: job.value?.employmentPeriod
                          }, null, 8, _hoisted_62))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_63, "更新時期"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 3,
                            class: "word_break",
                            innerHTML: job.value?.employmentPeriodUpdTiming
                          }, null, 8, _hoisted_64))
                        : _createCommentVNode("", true),
                      _hoisted_65,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.income
                      }, null, 8, _hoisted_66),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_67, "給与備考"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 5,
                            class: "word_break",
                            innerHTML: job.value?.annualincmMemo
                          }, null, 8, _hoisted_68))
                        : _createCommentVNode("", true),
                      _hoisted_69,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.allowance
                      }, null, 8, _hoisted_70),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_71, "給与形態"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 7,
                            class: "word_break",
                            innerHTML: job.value?.incmtype
                          }, null, 8, _hoisted_72))
                        : _createCommentVNode("", true),
                      _hoisted_73,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.insurance
                      }, null, 8, _hoisted_74),
                      _hoisted_75,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.allowances
                      }, null, 8, _hoisted_76),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_77, "制度面の備考"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 9,
                            class: "word_break",
                            innerHTML: job.value?.memo1
                          }, null, 8, _hoisted_78))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_79,
                    _createElementVNode("dl", _hoisted_80, [
                      _hoisted_81,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.wkhours
                      }, null, 8, _hoisted_82),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_83, "残業時間"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 1,
                            class: "word_break",
                            innerHTML: job.value?.possibleovertime
                          }, null, 8, _hoisted_84))
                        : _createCommentVNode("", true),
                      _hoisted_85,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.holidays
                      }, null, 8, _hoisted_86),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_87, "休日休暇補足"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 3,
                            class: "word_break",
                            innerHTML: job.value?.holidaycodicil
                          }, null, 8, _hoisted_88))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_89, "転勤"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 5,
                            class: "word_break",
                            innerHTML: job.value?.transfer
                          }, null, 8, _hoisted_90))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_91, "リモートワークの有無"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 7,
                            class: "word_break",
                            innerHTML: job.value?.remotework
                          }, null, 8, _hoisted_92))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_93, "副業の可否"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 9,
                            class: "word_break",
                            innerHTML: job.value?.sidebusiness
                          }, null, 8, _hoisted_94))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_95, "受動喫煙防止のための取り組み"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 11,
                            class: "word_break",
                            innerHTML: job.value?.passivesmoking
                          }, null, 8, _hoisted_96))
                        : _createCommentVNode("", true)
                    ]),
                    (!isBooster.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, _hoisted_100))
                      : _createCommentVNode("", true),
                    (!isBooster.value)
                      ? (_openBlock(), _createElementBlock("dl", _hoisted_101, [
                          _hoisted_102,
                          _createElementVNode("dd", {
                            class: "word_break",
                            innerHTML: job.value?.interviewmemo
                          }, null, 8, _hoisted_103),
                          _hoisted_104,
                          _createElementVNode("dd", {
                            class: "word_break",
                            innerHTML: job.value?.selectionLocationName
                          }, null, 8, _hoisted_105),
                          _hoisted_106,
                          _createElementVNode("dd", {
                            class: "word_break",
                            innerHTML: job.value?.selectionId
                          }, null, 8, _hoisted_107),
                          _hoisted_108,
                          _createElementVNode("dd", {
                            class: "word_break",
                            innerHTML: job.value?.selectionOthercontent
                          }, null, 8, _hoisted_109)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("div", _hoisted_111, [
                      _hoisted_112,
                      _createElementVNode("span", _hoisted_113, _toDisplayString(job.value?.companyName), 1)
                    ]),
                    _createElementVNode("dl", _hoisted_114, [
                      _hoisted_115,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.representative
                      }, null, 8, _hoisted_116),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_117, "概要"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 1,
                            class: "word_break",
                            innerHTML: job.value?.resume
                          }, null, 8, _hoisted_118))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_119, "事業所"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 3,
                            class: "word_break",
                            innerHTML: job.value?.indsctg
                          }, null, 8, _hoisted_120))
                        : _createCommentVNode("", true),
                      _hoisted_121,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.capital
                      }, null, 8, _hoisted_122),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_123, "株式公開"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 5,
                            class: "word_break",
                            innerHTML: job.value?.marketid
                          }, null, 8, _hoisted_124))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_125, "資本系列"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 7,
                            class: "word_break",
                            innerHTML: job.value?.frigncptlflg
                          }, null, 8, _hoisted_126))
                        : _createCommentVNode("", true),
                      _hoisted_127,
                      _createElementVNode("dd", null, [
                        (job.value?.clienturl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "word_break",
                              href: job.value?.clienturl,
                              target: "_blank"
                            }, _toDisplayString(job.value?.clienturl), 9, _hoisted_128))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_129,
                      _createElementVNode("dd", {
                        class: "word_break",
                        innerHTML: job.value?.busicontents
                      }, null, 8, _hoisted_130),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_131, "企業の特色"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 9,
                            class: "word_break",
                            innerHTML: job.value?.compfeature
                          }, null, 8, _hoisted_132))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_133, "社風・環境"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 11,
                            class: "word_break",
                            innerHTML: job.value?.compstyle
                          }, null, 8, _hoisted_134))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dt", _hoisted_135, "業績"))
                        : _createCommentVNode("", true),
                      (!isBooster.value)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_136, [
                            (job.value?.planresult)
                              ? (_openBlock(), _createElementBlock("table", _hoisted_137, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_138,
                                      _createElementVNode("th", null, _toDisplayString(job.value?.planresult.resultamount1_title), 1),
                                      _createElementVNode("th", null, _toDisplayString(job.value?.planresult.resultamount2_title), 1)
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.planresult_when), 1),
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.planresult_value1), 1),
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.planresult_value2), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.actualresult1_when), 1),
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.actualresult1_value1), 1),
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.actualresult1_value2), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.actualresult2_when), 1),
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.actualresult2_value1), 1),
                                      _createElementVNode("td", null, _toDisplayString(job.value?.planresult.actualresult2_value2), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "p-jobsearch-btn __link __white word_break",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClickSearchCompany(job.value.companyName ?? '')))
                  }, [
                    _createTextVNode(_toDisplayString(job.value?.companyName) + "の求人一覧を見る", 1),
                    _hoisted_139
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-jobsearch-detail-cta", { 'is-booster-about-centered': isBooster.value && !job.value?.entryFormUrl?.trim() }])
                  }, [
                    (isBooster.value && job.value?.entryFormUrl?.trim())
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "p-jobsearch-btn __blue",
                          href: buildEntryFormUrl(job.value.entryFormUrl),
                          target: "_blank"
                        }, "マイナビ転職 で応募する", 8, _hoisted_140))
                      : _createCommentVNode("", true),
                    (isShowButtonApply.value && !isBooster.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (isShowLabelPublic.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: "p-jobsearch-btn __blue",
                                to: `/apply/form/${job.value.orderId}/public`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("この求人に応募する")
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "p-jobsearch-btn __blue",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (checkProgress(handleNavigateToApplyByProgress(job.value.orderProgressType))))
                              }, "この求人に応募する"))
                        ], 64))
                      : _createCommentVNode("", true),
                    (isShowButtonAfterApply.value)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_141, "応募済み"))
                      : _createCommentVNode("", true),
                    ((isShowLabelPublic.value || isShowButtonLike.value) && !isBooster.value)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_142, [
                          _createElementVNode("input", {
                            ref_key: "favoriteIconTop",
                            ref: favoriteIconTop,
                            type: "checkbox",
                            checked: job.value.isLiked,
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (handleChangeJobFavorite(job.value.isLiked ?? false)))
                          }, null, 40, _hoisted_143),
                          _hoisted_144,
                          _hoisted_145,
                          _hoisted_146
                        ]))
                      : _createCommentVNode("", true),
                    (isBooster.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          type: "button",
                          class: "p-jobsearch-booster-about p-jobsearch-booster-about--top",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleShowBoosterInfoModal(true)))
                        }, _hoisted_149))
                      : _createCommentVNode("", true),
                    (isShowButonRefusal.value && !isShowLabelPublic.value)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 5,
                          class: "p-jobsearch-detail-donotapply",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (checkProgress('refusal')))
                        }, "応募しない"))
                      : _createCommentVNode("", true)
                  ], 2),
                  _withDirectives(_createElementVNode("div", _hoisted_150, [
                    _createElementVNode("div", {
                      class: "c-modal js-modal-container",
                      ref_key: "modalRef",
                      ref: modalRef,
                      id: "apply"
                    }, [
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("button", {
                          class: "c-modal_close js-modal-close-trigger",
                          type: "button",
                          "aria-label": "閉じる",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (handleShowModalError(false)))
                        }),
                        _createElementVNode("div", _hoisted_152, [
                          _createElementVNode("div", _hoisted_153, [
                            _createElementVNode("div", _hoisted_154, [
                              _createElementVNode("div", null, [
                                _hoisted_155,
                                _createElementVNode("p", _hoisted_156, _toDisplayString(errorMessageFavorite.value), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  class: "p-apply-modal_button -apply",
                                  type: "button",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (handleShowModalError(false)))
                                }, "OK")
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_157
                    ], 512)
                  ], 512), [
                    [_vShow, errorMessageFavorite.value.length > 0]
                  ])
                ]),
                _createElementVNode("div", _hoisted_158, [
                  _createElementVNode("a", {
                    class: "g-pagetop",
                    href: "#",
                    onClick: _withModifiers(scrollToTop, ["prevent"]),
                    "aria-label": "ページトップへ戻る"
                  }, _hoisted_161, 8, _hoisted_159)
                ]),
                _createElementVNode("div", _hoisted_162, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-jobsearch-detail_sub_inner", { 'is-booster-about-centered': isBooster.value && !job.value?.entryFormUrl?.trim() }])
                  }, [
                    (isBooster.value && job.value?.entryFormUrl?.trim())
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "p-jobsearch-btn __blue",
                          href: buildEntryFormUrl(job.value.entryFormUrl),
                          target: "_blank"
                        }, "マイナビ転職 で応募する", 8, _hoisted_163))
                      : _createCommentVNode("", true),
                    (isShowButtonApply.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (isShowLabelPublic.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: "p-jobsearch-btn __blue",
                                to: `/apply/form/${job.value.orderId}/public`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("この求人に応募する")
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "p-jobsearch-btn __blue",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (checkProgress(handleNavigateToApplyByProgress(job.value.orderProgressType))))
                              }, "この求人に応募する"))
                        ], 64))
                      : _createCommentVNode("", true),
                    (isShowButtonAfterApply.value)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_164, "応募済み"))
                      : _createCommentVNode("", true),
                    ((isShowLabelPublic.value || isShowButtonLike.value) && !isBooster.value)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_165, [
                          _createElementVNode("input", {
                            ref_key: "favoriteIconBottom",
                            ref: favoriteIconBottom,
                            type: "checkbox",
                            checked: job.value.isLiked,
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (handleChangeJobFavorite(job.value.isLiked ?? false)))
                          }, null, 40, _hoisted_166),
                          _hoisted_167,
                          _hoisted_168,
                          _hoisted_169
                        ]))
                      : _createCommentVNode("", true),
                    (isBooster.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          type: "button",
                          class: "p-jobsearch-booster-about p-jobsearch-booster-about--bottom",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (handleShowBoosterInfoModal(true)))
                        }, _hoisted_172))
                      : _createCommentVNode("", true),
                    (isShowButonRefusal.value && !isShowLabelPublic.value)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 5,
                          class: "p-jobsearch-detail-donotapply",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (checkProgress('refusal')))
                        }, "応募しない"))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["c-modal js-modal-container", { 'is-active': isShowBoosterInfoModal.value }]),
          id: "booster-info"
        }, [
          _createElementVNode("div", { class: "p-recommend-form__modal-card -is-complete" }, [
            _createElementVNode("button", {
              class: "p-recommend-form__modal-help-close js-modal-close-trigger",
              type: "button",
              onClick: hidePopup
            }, "閉じる"),
            _hoisted_173
          ]),
          _createElementVNode("div", {
            class: "c-modal_bg js-modal-close-trigger",
            onClick: hidePopup
          })
        ], 2)
      ])
    ]),
    _createVNode(Loading, {
      "is-loading": isLoading.value || !isAction.value
    }, null, 8, ["is-loading"])
  ], 64))
}
}

})